import React from "react"
import ProgressiveImage from "react-progressive-image-loading";

const ImageSlider = ({image, handleOpenGallery, index}) => {
    return (
        <a className="thumbnail-modern" onClick={(e) => handleOpenGallery(e, index)} href={image}
           data-lightgallery="item">
            <ProgressiveImage
                preview="/images/about-placeholder.png"
                src={image}
                render={(src, style) =>
                    <img className="img-responsive thumbnail-modern-image" alt="" src={src} style={style}/>}
            />
            <div className="thumbnail-modern-caption"><i className="fas fa-search"></i></div>
            <div className="thumbnail-modern-dummy"></div>
        </a>
    )
}

export default ImageSlider